var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSynchronizeArrows = function SvgSynchronizeArrows(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.42578 20.6797L6.99978 28.9797L13.4098 21.3037",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97805 28.8785C5.90314 24.2973 6.67606 19.477 9.12944 15.4616C11.5828 11.4461 15.5192 8.55865 20.0861 7.42448C23.0795 6.71433 26.2096 6.83062 29.1421 7.76092C32.0747 8.69122 34.6994 10.4006 36.7361 12.7065",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5699 27.2835L40.9959 18.9795L34.5859 26.6555",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0178 19.0859C42.0921 23.6671 41.319 28.4871 38.8657 32.5024C36.4124 36.5178 32.4764 39.4053 27.9098 40.5399C24.9163 41.2483 21.7866 41.1312 18.8545 40.201C15.9223 39.2708 13.2975 37.5624 11.2598 35.2579",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.9824C26.2091 27.9824 28 26.1916 28 23.9824C28 21.7733 26.2091 19.9824 24 19.9824C21.7909 19.9824 20 21.7733 20 23.9824C20 26.1916 21.7909 27.9824 24 27.9824Z",
    fill: "#0258FF",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSynchronizeArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/synchronize-arrows.4001ab32.svg";
export { ForwardRef as ReactComponent };